/* @ngInject */

export default (
  $q,
  $rootScope,
  $scope,
  $state,
  webpage,
  eventService,
  fileFactory,
  documentService,
  documentsService,
  actionService,
  uiService,
  mergeFieldsService,
  labelsService,
  Document,
  DOCUMENT
) => {
  $scope.Model = {
    availableDocuments: [],
    availableFileLabels: [],
    documentsList: null,
    mergeFields: [],
    isMergeFieldsVisible: false,
    watcher: null,
    isArchive: false,
    isReady: false
  };

  /*
   * Initialize controller and start loading the required data
   * --------------------------------------------------------------------------------
   */
  if ($rootScope.CurrentAccount.isAdministrator) {
    loadDocuments();
  }

  function loadDocuments() {
    webpage.pageTitle('Loading, please wait');
    $q.all([
      documentsService.getAvailable({
        isActive: !$scope.Model.isArchive,
        isCompliance: true
      }),
      mergeFieldsService.getFields(true),
      labelsService.getAvailable({
        type: 'file',
        orderBy: 'name',
        coerceTo: 'string',
        isDescending: false,
        isActive: true
      })
    ])
      .then(function (data) {
        // Set Model values
        $scope.Model.availableDocuments = data[0];
        $scope.Model.mergeFields = data[1];
        $scope.Model.availableFileLabels = data[2];
      })
      .then(function () {
        // Declare Model as Ready and start rendering the page
        webpage.pageTitle('Merge templates : Settings');
        $scope.Model.isReady = true;
      });
  }

  /*
   * Events available in Controller Scope
   * --------------------------------------------------------------------------------
   */
  $scope.$on('documentDelete', function () {
    documentsService.clearCache();
    actionService.deleteDocuments(
      $scope.Model.documentsList.getSelected(),
      documentService.deleteDocument,
      $scope.Model.documentsList.removeData,
      'merge template(s)'
    );
  });
  $scope.$on('documentDuplicate', function () {
    documentsService.clearCache();
    actionService.duplicateDocuments(
      $scope.Model.documentsList.getSelected(),
      documentService.readDocument,
      documentService.createDocument,
      $scope.Model.documentsList.setDataAppend,
      'name',
      ' copy',
      'merge template(s)'
    );
  });
  $scope.$on('documentActivate', function () {
    documentsService.clearCache();
    actionService.toggleDocuments(
      $scope.Model.documentsList.getSelected(),
      documentService.updateDocument,
      $scope.Model.documentsList.removeData,
      'merge template(s)',
      true
    );
  });
  $scope.$on('documentArchive', function () {
    documentsService.clearCache();
    actionService.toggleDocuments(
      $scope.Model.documentsList.getSelected(),
      documentService.updateDocument,
      $scope.Model.documentsList.removeData,
      'merge template(s)',
      false
    );
  });
  $scope.$on('documentRename', function (e, $event) {
    documentsService.clearCache();
    eventService.documentRename({
      event: $event,
      document: $scope.Model.documentsList.getSelected()[0]
    });
  });
  $scope.$on('documentAdd', function (e, $event) {
    documentsService.clearCache();
    eventService.documentAdd({ event: $event });
  });
  $scope.$on('documentMergeFields', function () {
    $scope.Model.isMergeFieldsVisible = true;
  });

  /*
   * Methods available in Controller Scope
   * --------------------------------------------------------------------------------
   */
  $scope.documentDownload = function ($event, document) {
    fileFactory
      .getDownloadUrl({
        url: DOCUMENT.API.DOWNLOAD,
        file: document.file,
        name: document.name
      })
      .then(function (downloadUrl) {
        fileFactory.download(downloadUrl);
      });
  };
  $scope.previewPdf = function ($event, document) {
    $event.stopPropagation();
    uiService.toast({
      text: {
        p1: 'Downloading for preview',
        p2: document.name,
        p3: 'Please wait while file is processing.'
      }
    });
    documentService.previewPdf({
      idDocument: document.id,
      name: document.name
    });
  };
  $scope.editPdf = function ($event, data) {
    $event.stopPropagation();
    $state.transitionTo('settings.documents-fill-pdf', { id: data.id });
  };

  $scope.documentAdded = function (documents) {
    documentsService.clearCache();
    var isNew = false;
    var len = documents.length;
    while (len--) {
      if (documents[len].isNew) {
        isNew = true;
      }
      delete documents[len].isNew;
    }
    if (isNew === true) {
      if (_.some(documents, { isActive: true }) !== $scope.Model.isArchive) {
        $scope.Model.documentsList.setDataAppend(documents);
      }
    } else {
      $scope.Model.documentsList.setDataReplace(documents);
    }
    if (documents.length === 1 && documents[0].fields.length) {
      $state.transitionTo('settings.documents-fill-pdf', { id: documents[0].id });
    }
  };
  $scope.documentRenamed = function (documents) {
    documentsService.clearCache();
    $scope.Model.documentsList.setDataReplace(documents);
  };
  $scope.documentRenamed = function (documents) {
    documentsService.clearCache();
    $scope.Model.documentsList.setDataReplace(documents);
  };
  $scope.documentLabelsSelect = function ($event, document) {
    eventService.dialogLabelSelect({
      event: $event,
      labels: $scope.Model.availableFileLabels,
      selectedLabels: document.idLabels,
      data: document
    });
  };
  $scope.documentLabelsSelected = function (selectedLabels, document) {
    document.idLabels = selectedLabels;
    documentsService.clearCache();
    $scope.Model.documentsList.setDataReplace(document);
    documentService.updateDocument(document);
  };
  $scope.listChange = function (list, data, isSelected) {
    $scope.$parent.Model.childStateHasSelection = isSelected
      ? isSelected
      : list.isSelectedAny();
  };
  $scope.listReady = function (list) {
    $scope.Model.documentsList = list;
    $scope.Model.watcher = $scope.$parent.$watch('Model.childStateIsArchive', function (
      newValue,
      oldValue
    ) {
      if (newValue !== oldValue) {
        $scope.Model.isArchive = newValue;
        $scope.Model.isReady = false;
        $scope.Model.watcher();
        loadDocuments();
      }
    });
  };
};
